oyc.Video = {
  dependencies: ['Modal'],

  selectors: {
    videoEmbed: '.video-embed',
    playButton: '.video-play-button',
    iframeContainer: '.iframe',
    videoElement: 'video',
    embedIdAttr: 'data-embed-id',
    modalTarget: 'data-modal-target',
    section: 'section',
    header: '#site-header'
  },

  classes: {
    playing: 'is-playing',
    hidden: 'hidden'
  },

  activeVideoEmbed: null,

  init: function () {
    window.addEventListener('UC_UI_INITIALIZED', function () {
      oyc.UserCentrics.handleConsent('.video-embed__no-cookie', 'BJz7qNsdj-7');
    });

    document.addEventListener('modal:opened', this.handleModalOpened.bind(this));
    document.addEventListener('modal:closed', this.handleModalClosed.bind(this));

    this.initInlineVideos();
  },

  initInlineVideos: function () {
    const playButtons = document.querySelectorAll(this.selectors.playButton);

    playButtons.forEach((button) => {
      const hasModal = button.hasAttribute(this.selectors.modalTarget);

      if (!hasModal) {
        button.addEventListener('click', this.handleInlinePlayClick.bind(this, button));

        const embedId = button.getAttribute(this.selectors.embedIdAttr);
        const videoType = embedId ? 'YouTube' : 'Local';
        button.setAttribute('aria-label', `${videoType} Video abspielen`);
      }
    });
  },

  handleInlinePlayClick: function (button) {
    const videoEmbed = button.closest(this.selectors.videoEmbed);
    if (!videoEmbed) return;

    this.stopAllVideos(videoEmbed);

    const embedId = button.getAttribute(this.selectors.embedIdAttr);
    const iframeContainer = videoEmbed.querySelector(this.selectors.iframeContainer);
    const videoElement = videoEmbed.querySelector(this.selectors.videoElement);

    button.classList.add(this.classes.hidden);
    const figure = videoEmbed.querySelector('figure');
    if (figure) {
      figure.classList.add(this.classes.hidden);
    }

    videoEmbed.classList.add(this.classes.playing);

    this.activeVideoEmbed = videoEmbed;

    this.scrollToSection(videoEmbed);

    if (embedId && iframeContainer) {
      this.createYouTubeIframe(embedId, iframeContainer, true);
      iframeContainer.setAttribute('role', 'region');
      iframeContainer.setAttribute('aria-label', 'YouTube Video Player');
    } else if (videoElement) {
      videoElement.classList.remove(this.classes.hidden);
      this.playHtml5Video(videoElement);
      videoElement.setAttribute('aria-label', 'Video Player');
      videoElement.focus();
    }
  },

  stopAllVideos: function (exceptVideoEmbed = null) {
    const allPlayingVideos = document.querySelectorAll(this.selectors.videoEmbed + '.' + this.classes.playing);

    allPlayingVideos.forEach((videoEmbed) => {
      if (exceptVideoEmbed && videoEmbed === exceptVideoEmbed) {
        return;
      }

      const iframeContainer = videoEmbed.querySelector(this.selectors.iframeContainer);
      if (iframeContainer) {
        this.removeYouTubeIframe(iframeContainer);
      }

      const videoElement = videoEmbed.querySelector(this.selectors.videoElement);
      if (videoElement) {
        this.stopHtml5Video(videoElement);
        videoElement.classList.add(this.classes.hidden);
      }

      videoEmbed.classList.remove(this.classes.playing);

      const playButton = videoEmbed.querySelector(this.selectors.playButton);
      if (playButton) {
        playButton.classList.remove(this.classes.hidden);
      }

      const figure = videoEmbed.querySelector('figure');
      if (figure) {
        figure.classList.remove(this.classes.hidden);
      }
    });

    if (this.activeVideoEmbed && !exceptVideoEmbed) {
      this.activeVideoEmbed = null;
    }
  },

  scrollToSection: function (videoEmbed) {
    const section = videoEmbed.closest(this.selectors.section);
    if (!section) return;

    const header = document.querySelector(this.selectors.header);
    const headerHeight = header ? header.outerHeight || header.offsetHeight : 0;

    const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
    const scrollToPosition = sectionTop - headerHeight;

    window.scrollTo({
      top: scrollToPosition,
    });
  },

  handleModalOpened: function (event) {
    const overlay = event.detail.overlay;
    const triggerButton = event.detail.triggerButton;
    const elements = this.getElements(overlay, triggerButton);

    this.stopAllVideos();

    if (elements.embedId) {
      overlay.dataset.embedId = elements.embedId;
    }

    if (elements.isYouTube && elements.embedId && elements.iframeContainer) {
      this.createYouTubeIframe(elements.embedId, elements.iframeContainer, true);
      elements.iframeContainer.setAttribute('role', 'region');
      elements.iframeContainer.setAttribute('aria-label', 'YouTube Video Player im Modal');
    } else if (elements.videoElement) {
      this.playHtml5Video(elements.videoElement);
      elements.videoElement.setAttribute('aria-label', 'Video Player im Modal');
    }
  },

  handleModalClosed: function (event) {
    const overlay = event.detail.overlay;
    const elements = this.getElements(overlay);

    if (elements.isYouTube && elements.iframeContainer) {
      this.removeYouTubeIframe(elements.iframeContainer);
    } else if (elements.videoElement) {
      this.stopHtml5Video(elements.videoElement);
    }
  },

  getElements: function (overlay, triggerButton = null) {
    const iframeContainer = overlay.querySelector(this.selectors.iframeContainer);
    const videoElement = overlay.querySelector(this.selectors.videoElement);
    const embedId = triggerButton
      ? triggerButton.getAttribute(this.selectors.embedIdAttr)
      : overlay.dataset.embedId || overlay.querySelector(`[${this.selectors.embedIdAttr}]`)?.getAttribute(this.selectors.embedIdAttr);

    return {
      iframeContainer,
      videoElement,
      embedId,
      isYouTube: Boolean(embedId)
    };
  },

  createYouTubeIframe: function (embedId, iframeContainer, autoplay = false) {
    if (!iframeContainer) return;

    this.removeYouTubeIframe(iframeContainer);

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${embedId}?rel=0&showinfo=0${autoplay ? '&autoplay=1' : ''}`;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.allow = 'autoplay; encrypted-media';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('tabindex', '0');
    iframe.setAttribute('title', 'YouTube Video Player');

    iframeContainer.appendChild(iframe);

    iframe.addEventListener('load', function() {
      iframe.focus();
    });
  },

  removeYouTubeIframe: function (iframeContainer) {
    if (!iframeContainer) return;

    const existingIframe = iframeContainer.querySelector('iframe');
    if (existingIframe) {
      existingIframe.src = '';
      existingIframe.remove();
    }

    iframeContainer.innerHTML = '';
  },

  playHtml5Video: function (videoElement) {
    if (!videoElement) return;

    videoElement.play().catch(function(error) {
      console.error('Video playback failed:', error);
    });
  },

  stopHtml5Video: function (videoElement) {
    if (!videoElement) return;

    videoElement.pause();
    videoElement.currentTime = 0;
  }
};
